import { render, staticRenderFns } from "./contractEvidenceInfo.vue?vue&type=template&id=b39aacf2&scoped=true"
import script from "./contractEvidenceInfo.vue?vue&type=script&lang=js"
export * from "./contractEvidenceInfo.vue?vue&type=script&lang=js"
import style0 from "./contractEvidenceInfo.vue?vue&type=style&index=0&id=b39aacf2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39aacf2",
  null
  
)

export default component.exports